var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35 17.4764C35 29.1431 20 39.1431 20 39.1431C20 39.1431 5 29.1431 5 17.4764C5 13.4982 6.58035 9.68288 9.3934 6.86984C12.2064 4.05679 16.0218 2.47644 20 2.47644C23.9782 2.47644 27.7936 4.05679 30.6066 6.86984C33.4196 9.68288 35 13.4982 35 17.4764Z",
    fill: "#E03131"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20 22.4764C22.7614 22.4764 25 20.2379 25 17.4764C25 14.715 22.7614 12.4764 20 12.4764C17.2386 12.4764 15 14.715 15 17.4764C15 20.2379 17.2386 22.4764 20 22.4764Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapAlert);
export default __webpack_public_path__ + "static/media/map_alert.5c5c3e9146990115ef1a129b9d3ab185.svg";
export { ForwardRef as ReactComponent };